export class MyClientsReSignEmailFauRequestModel {
    id: string; // Id que se genera en la plataforma
    idOld: number | null; // Dependencia de 1re servicio
    radicacion: number;
    direccion: string;
    ciudad: string;
    cupoComprador: number;
    documento: number;
    documentoAfiliado: number;
    nombreComprador: string;
    tipoDoc: string;
    tipoDocAfiliado: string;
    correosComprador: string[] = [];
    celulares: string[] = [];
    token?: string;
    urlCupo: string;
    urlLanding: string;
    whatsApp: boolean;
    sms: boolean;
    llamada: boolean;
    correoElectronico: boolean;
    fecha_expedicion: string;
    usuario: string;
    firmaPagare?: boolean
  }

  export interface MyClientsReSignEmailFauResponse {
  ok: boolean
  message: string
  data: MyClientsReSignEmailFauResponseData
  status: number
}

export interface MyClientsReSignEmailFauResponseData {
  id: string
  idOld: any
  radicacion: string
  direccion: string
  ciudad: string
  celulares: string[]
  fecha: string
  urlCupo: string
  token: string
  tipoDoc: string
  documento: string
  cupoComprador: string
  tipoDocAfiliado: string
  documentoAfiliado: string
  correosComprador: string[]
  urlLanding: string
  firmaDigital: boolean
  envioCorreoNoFirma: boolean
  nombreComprador: string
  whatsApp: boolean
  sms: boolean
  llamada: boolean
  correoElectronico: boolean
  fecha_expedicion: string
  usuario: string
}

  